import { useEffect, useState } from 'react';
import className from 'classnames/bind';
import { REDUCE_MOTION_CHANNEL_NAME, getReduceMotion, setReduceMotion } from '@/utils/reduceMotion';

import styles from './ReduceMotionToggle.module.scss';
import { usePageWrapperData } from '@/providers/PageWrapperContext';
const cx = className.bind(styles);

type ReduceMotionToggleProps = {
  className?: string;
  dataGtmSection?: string;
};

export default function ReduceMotionToggle({ className = '', dataGtmSection }: ReduceMotionToggleProps) {
  const [isChecked, setIsChecked] = useState<boolean>(false);
  const { labels } = usePageWrapperData(); 
  const reduceMotionLabel = labels?.reduceMotion || 'Reduce Motion';
  useEffect(() => {
    setIsChecked(getReduceMotion());
  }, []);

  useEffect(() => {
    if (typeof window === 'undefined' || typeof BroadcastChannel === 'undefined') return;
    const channel = new BroadcastChannel(REDUCE_MOTION_CHANNEL_NAME);
    channel.onmessage = (event) => {
      if (typeof event.data?.checked === 'boolean') {
        setIsChecked(event.data.checked);
      }
    };
    return () => channel.close();
  }, []);

  const onClick = () => {
    const newValue = !isChecked;
    setIsChecked(newValue);
    setReduceMotion(newValue);
  };

  return (
    <button className={cx('reduce-motion', 'text-m', { checked: isChecked }, className)} onClick={onClick} data-gtm-section={dataGtmSection}>
      <span>{reduceMotionLabel}</span>
      <i />
    </button>
  );
}